import UserAvatarCard from '@components/UI/UserAvatarCard/UserAvatarCard';
import { ICTask } from '@Helper/Interfaces';
import React, { FC } from 'react';

type IProps = {
  data: any;
  updateTaskProperty?: (taskId: string, property: string, value: any) => any;
  editable?: boolean;
};

const UserCell: FC<IProps> = ({ data, updateTaskProperty, editable }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
      }}
    >
      <UserAvatarCard
        task={data.data.data}
        updateTask={(currentTask: ICTask, username: string) =>
          updateTaskProperty &&
          updateTaskProperty(
            currentTask.id!,
            'assignee',
            username !== '' ? username : null
          )
        }
        disabled={!editable}
      />{' '}
    </div>
  );
};

export default UserCell;
